import React, { Component } from 'react'
// import Settings from '../settings'

// This component has:
// 1. Title
// 2. Dividing Line

class SectionDivider extends Component {

   render() {
      const {
        title = 'Test Title',
        color = 'orange',
        style = 'solid',
      } = this.props.data

      const dividerClass = `divider divider-${style} divider-${color}`

      return (
         <div className="SectionDivider">

           <div className={dividerClass}>
             {title && <div className="page-width"><div className="section-title divider-title">{title}</div></div>}
             <svg width="100%"><line x1="100%" y1="0%" x2="0%" y2="0%" stroke="#fff" strokeWidth="1"></line></svg>
           </div>

         </div>
      )
   }
}

export default SectionDivider



// WEBPACK FOOTER //
// ./src/components/SectionDivider.js